import React from 'react'
import CreateAccountPage from '../../components/Fundraiser/FundraiserOnboarding/CreateAccount';

const CreateAccount = () => {
  return (
    <CreateAccountPage />
  )
}

export default CreateAccount;